export enum ViewerActionTypes {
  FETCH_REQUEST = 'viewers/FETCH_REQUEST',
  FETCH_ERROR = 'viewers/FETCH_ERROR',
  FETCH_SUCCESS = 'viewers/FETCH_SUCCESS',
  FETCH_NEXT_SUCCESS = 'viewers/FETCH_NEXT_SUCCESS',
  FETCH_NEXT_ERROR = 'viewers/FETCH_NEXT_ERROR',
  FETCH_NEXT_REQUEST = 'viewers/FETCH_NEXT_REQUEST',
}
